// @flow
import ProductGalleryThumb from './ProductGalleryThumb';

export default ProductGalleryThumb;
